import axios from "axios";
import qs from "qs";
import { message } from "antd";

// 创建 Axios 实例
const http = axios.create({
  // baseURL:  '/api2', // 设置默认的请求基础URL
  timeout: 1000 * 60 * 10, // 超时时间设置为10分钟
});

// 请求拦截器
http.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("access_token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    if (
      config.data &&
      !(config.data instanceof FormData) &&
      typeof config.data !== "string"
    ) {
      config.data = qs.stringify(config.data);
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
http.interceptors.response.use(
  (response) => {
    return response.data;
  },
  async (error) => {
    console.log(error.response.status);
    if(error.response.data.detail === '找不到指定凭据对应的有效用户'){
      message.error("Wrong username or password!");
    }
    if(error.response.data.error){
      message.error(error.response.data.error);
    }
    if(error.response.status==429){
      message.error("Please try again"+error.response.data.detail.split('请求超过了限速。 Expected available')[1])
    }
    return Promise.reject(error);
  }
);

export default http;
